export default __webpack_public_path__ + "static/Search-Engine-Optimization-de3db79b91333a3950095e63d4572f07.webp";